/* eslint-disable react/jsx-key */
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { IoNotificationsOutline } from "react-icons/io5";
import { BsEnvelopeOpen } from "react-icons/bs";
// import { notifications } from "../../../data";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import NotificationController, {
  useNotifications,
} from "../../../controllers/NotificationController";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { toast } from "react-toastify";
import { FaRegEnvelope } from "react-icons/fa";
import moment from "moment";
import { useEnums } from "../../../hooks/useEnums";

const Notifications = () => {
  const { notifications, loading } = useNotifications();
  const awsUrl = useEnums();
  const markAllEnabled =
    notifications?.length > 0 &&
    notifications.some((notification) => !notification.markedAsRead);

  async function handleMarkAll(id = undefined) {
    const toastId = toast("Updating Notification...", { autoClose: false });

    try {
      await NotificationController.markAsRead(id);
    } catch (error) {
      console.log("Notification Catch Error...");
    } finally {
      toast.dismiss(toastId);
    }
  }
  console.log(notifications, "@notifications");
  return (
    <DropdownMenu className={`relative `}>
      <DropdownMenuTrigger
        className={`outline-none relative text-[#6C757D] active:text-primary transition-all duration-300 flex items-center`}
      >
        <IoNotificationsOutline className="text-base sm:text-xl" />
        {markAllEnabled && (
          <div className="absolute top-[-1px] right-[-2px] bg-primary rounded-full w-[6px] h-[6px] content-[' ']"></div>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={`absolute max-h-[300px] overflow-y-auto dark:text-white text-black p-3 top-1 -right-4 sm:right-0 min-w-[230px] sm:min-w-max w-full rounded-2xl dark:shadow-none drop-shadow-none border-none dark:bg-dark3 bg-white shadow-xl `}
      >
        <DropdownMenuLabel className={`flex items-center justify-between`}>
          <h3 className="text-[14px] font-lato_bold">Notifications</h3>
          <button
            onClick={() => handleMarkAll()}
            title="Mark all read"
            className="cursor-pointer disabled:cursor-not-allowed"
            disabled={!markAllEnabled}
          >
            {!markAllEnabled ? (
              <BsEnvelopeOpen />
            ) : (
              <div className="relative">
                <FaRegEnvelope />
                <div className="absolute top-[-1px] right-[-2px] bg-primary rounded-full w-[6px] h-[6px] content-[' ']"></div>
              </div>
            )}
          </button>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />

        {loading ? (
          <div className="min-w-[200px]">
            <SkeletonTheme>
              <Skeleton />
              <Skeleton />
              <Skeleton />
            </SkeletonTheme>
          </div>
        ) : (
          notifications?.map((ls, index) => {
            const { payload, type, markedAsRead, body, _id, createdAt } = ls;
            console.log("====================================");
            console.log(ls, "@Web.....");
            console.log("====================================");
            return (
              <div onClick={() => markedAsRead == false && handleMarkAll(_id)}>
                <DropdownMenuItem key={index}>
                  <div className="flex relative -mb-2 w-full items-start cursor-pointer rounded-lg hover:bg-primary/20 transition-all duration-300 p-2  py-1 gap-[10px]">
                    <Avatar className={`w-8 h-8 sm:block hidden`}>
                      <AvatarImage
                        src={
                          payload?.user?.profilePhoto?.avatar?.key
                            ? `${awsUrl}${payload.user.profilePhoto.avatar.key}`
                            : payload?.athlete?.profilePhoto?.avatar?.url
                            ? `${awsUrl}${payload.athlete.profilePhoto.avatar.url}`
                            : "/Assets/Images/notification.svg"
                        }
                      />
                      <AvatarFallback>CA</AvatarFallback>
                    </Avatar>
                    <div className="flex flex-col max-w-[216px] w-full ">
                      <p className="text-xs !text-left font-lato_medium text-[#808282]">
                        <span className="mr-1 text-black capitalize font-lato_bold dark:text-white">
                          {/* {title} */}
                          {payload?.user?.username ||
                            payload?.athlete?.username}
                        </span>
                        {/* Purchased Workout Plan */}
                        {type === "newPlan" ? (
                          <span>
                            Create{" "}
                            {payload?.workoutPlan?.planName ? (
                              <q className="!font-lato_bold">
                                {payload?.workoutPlan?.planName}
                              </q>
                            ) : (
                              "new"
                            )}{" "}
                            workout plan
                          </span>
                        ) : type === "newOrder" ? (
                          "Purchased Workout Plan"
                        ) : type === "newAthlete" ? (
                          "New Athlete Registered"
                        ) : (
                          body
                        )}

                        {/* newPlan  newOrder newAthlete */}
                      </p>
                      <p className="text-[10px] text-[#5C677D]">
                        {moment(createdAt).fromNow()}
                      </p>
                      {!markedAsRead && (
                        <div className="absolute w-2 h-2 rounded-full bg-primary top-4 -left-3"></div>
                      )}
                    </div>
                  </div>
                </DropdownMenuItem>
              </div>
            );
          })
        )}
        {!loading && notifications?.length <= 0 && (
          <DropdownMenuItem>No new notification found!</DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default Notifications;
